import React, { useEffect, useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { AmountFormatCell } from "components/common/formatter";
import EditFeeHeaderItems from "./EditFeeHeaderItems";
import { ActiveCell, EditCommandCell } from "../GridComponents";
import { editFeeHeaderItemsAPI, getFeeHeaderItemsAPI } from "services/fixedfeeService";
import { toast } from "react-toastify";

const FixedFeeHeaderItemsList = (props) => {
  const [openForm, setOpenForm] = React.useState(false);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [editItem, setEditItem] = React.useState(null);

  useEffect(() => {
    const getFeeHeaderItems = async () => {
      setIsLoading(true);
      const data = await getFeeHeaderItemsAPI(props.item.fixedFeeHeaderID);
      setData(data.data);
      setIsLoading(false);
    };
    getFeeHeaderItems();
  }, [props.refreshTrigger, props.item.fixedFeeHeaderID]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };
  const handleSubmit = async (event) => {
    setIsLoading(true);
    try {
      if (typeof event.vatCode === "object") {
        event.vatRate = event?.vatCode.rate;
        event.vatAmount = (event.vatCode.rate / 100) * event.netAmount;
        event.vatCode = event.vatCode.vatCodeId;
      }

      const res = await editFeeHeaderItemsAPI(props.item.fixedFeeHeaderID, [event]);
      if (res.status === 200) {
        toast.success("Item updated successfully");
        setOpenForm(false);
        const updatedData = await getFeeHeaderItemsAPI(props.item.fixedFeeHeaderID);
        setData(updatedData.data);
      }
    } catch (error) {
      console.error("Error submitting:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );
  return (
    <div>
      {/* {isLoading && <LoadingPanel />} */}
      <Grid
        data={data}
        sortable={true}
        className="accounts-table p-4 pt-2 mb-4"
      >
        <Column field="details" title="Details" />
        <Column field="vatCode" title="Vat Code" />
        <Column field="nominalRef" title="Nominal Ref" />
        <Column field="netAmount" title="Net Amount" cell={AmountFormatCell} />
        <Column cell={ActiveCell} title="Active" width="80" />
        <Column title="Edit" cell={MyEditCommandCell} width="80" />
      </Grid>
      {openForm && (
        <EditFeeHeaderItems
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isLoading}
        />
      )}
    </div>
  );
};

export default FixedFeeHeaderItemsList;
